import store from '@/store';
import Vue from 'vue';

export const API_HOST = process.env.VUE_APP_API_HOST;
export const SHARE_HOST = process.env.VUE_APP_SHARE_HOST;

const endpoint = `${API_HOST}/graphql`;

export interface IQueryVariables {
  [varName: string]:
    | string
    | number
    | boolean
    | undefined
    | null
    | IQueryVariables
    | string[]
    | number[]
    | boolean[];
}

export interface IQueryError {
  message: string;
  path?: string[];
  state?: any;
}

export interface IRequestOptions {
  disableAuth?: boolean;
}

export const getAuthHeader = () => {
  const token = store.getters['auth/token'];
  return `Bearer ${token}`;
};

export const request = async (
  query: string,
  variables?: IQueryVariables,
  options?: IRequestOptions
): Promise<{ data: any; errors: IQueryError[] }> => {
  const headers: { [key: string]: string } = {
    'Content-Type': 'application/json',
  };

  // Add the auth token if it is provided
  if (
    (!options || !options.disableAuth) &&
    store.getters['auth/authenticated']
  ) {
    headers.Authorization = getAuthHeader();
  }

  if (process.env.NODE_ENV !== 'production') {
    console.dir({ query, variables });
  }

  return fetch(endpoint, {
    method: 'POST',
    headers,
    body: JSON.stringify({ query, variables }),
  })
    .then(response => response.json())
    .then(json => ({ data: json.data, errors: json.errors }));
};

export default request;
